import { render, staticRenderFns } from "./CmgLoyaltyExplainerModal.vue?vue&type=template&id=72123246&scoped=true&lang=pug"
import script from "./cmg-loyalty-explainer-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-loyalty-explainer-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLoyaltyExplainerModal.vue?vue&type=style&index=0&id=72123246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72123246",
  null
  
)

export default component.exports